import React from 'react'


function Loader () {
  return(
    <div>
      <h3 className="loader"> Loading... </h3>
    </div>
  )
}

export default Loader
